
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 192 192","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M120 0a8 8 0 00-7.428 5.029l-15.92 39.8a8.259 8.259 0 00-.352 5.371 8.014 8.014 0 007.7 5.8h88v-56zM128 168c-16 0-16-8-32-8s-16 8-32 8-16-8-32-8-16 8-32 8v24h192v-24c-16 0-16-8-32-8s-16 8-32 8zM128 136c-16 0-16-8-32-8s-16 8-32 8-16-8-32-8-16 8-32 8v24c16 0 16-8 32-8s16 8 32 8 16-8 32-8 16 8 32 8 16-8 32-8 16 8 32 8v-24c-16 0-16-8-32-8s-16 8-32 8z"}}),_c('circle',{attrs:{"cx":"128","cy":"88","r":"8"}}),_c('path',{attrs:{"d":"m88 120a24.027 24.027 0 0 0 24-24c0-11.391-14.158-25.694-18.5-29.807a8 8 0 0 0 -11.006 0c-4.336 4.113-18.494 18.416-18.494 29.807a24.027 24.027 0 0 0 24 24zm8-32a8 8 0 1 1 -8 8 8 8 0 0 1 8-8z"}}),_c('circle',{attrs:{"cx":"64","cy":"56","r":"8"}}),_c('circle',{attrs:{"cx":"40","cy":"104","r":"8"}})])
          )
        }
      }
    